import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircle, Loader2 } from 'lucide-react';

import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { api } from '@/lib/api';

/**
 * Snapchat's redirect, when the platform app uses the app-side address
 * (/app/oauth/snapchat/callback). The code and the signed state go to the
 * API, which keeps the connection, then back to the Snapchat drawer. The
 * API-side address needs no page: it redirects to the drawer itself.
 */
export default function OAuthSnapchatCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    const denied = p.get('error_description') || p.get('error');
    if (denied) { setError(`Snapchat did not grant access: ${denied}`); return; }
    if (!p.get('code')) { setError('Snapchat sent no authorisation code.'); return; }
    api.post('/api/settings/snap-leads/oauth/complete', { code: p.get('code'), state: p.get('state') })
      .then(({ data }) => navigate(`/integrations?open=snap_lead_ads&snap=connected&n=${data.count || 0}`, { replace: true }))
      .catch((err) => setError(err.response?.data?.error || err.message || 'Connecting Snapchat failed.'));
  }, [navigate]);

  return (
    <div className="flex min-h-[60vh] items-center justify-center px-4">
      <Card className="w-full max-w-md">
        <CardContent className="space-y-4 p-8 text-center">
          {!error ? (
            <>
              <Loader2 className="mx-auto size-8 animate-spin text-primary" />
              <h2 className="text-base font-semibold">Connecting Snapchat</h2>
            </>
          ) : (
            <>
              <AlertCircle className="mx-auto size-8 text-destructive" />
              <h2 className="text-base font-semibold">Snapchat did not connect</h2>
              <p className="text-sm text-muted-foreground">{error}</p>
              <Button onClick={() => navigate('/integrations?open=snap_lead_ads')}>Back to Snapchat Lead Ads</Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
